import "./EditableEntries.css";
import {useId, useRef} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCancel} from "@fortawesome/free-solid-svg-icons/faCancel";
import EditableEntry from "./EditableEntry";


export const UPLOAD_FILE_TYPE_IMAGE = "image/png,image/jpeg,image/png";
export const UPLOAD_FILE_TYPE_GENERIC = "image/png,image/jpeg,image/png,application/pdf";
export const UPLOAD_FILE_TYPE_REPORT = "text/csv";

const EditableCardEntryFile = ({onEdit, isEditing, displayLabel = "", accept}) => {
    const idRoot = useId();

    const inputt = useRef(null);

    return isEditing ? <EditableEntry
        isEditing={isEditing}
        id={idRoot}
        label={displayLabel}
        editingChildren={<div>
            <input ref={inputt} style={{display: "none"}} id={`${idRoot}-${displayLabel}`} type={"file"}
                   onInput={(e) => {
                       onEdit(e.target.files);
                   }} accept={accept}/>
            <button type={"button"} onClick={() => inputt.current.click()}>Select File</button>
            <FontAwesomeIcon icon={faCancel} onClick={() => {
                inputt.current.value = null;
                onEdit(inputt.current.files);
            }}/>
        </div>}
        viewingChildren={null}
    /> : null;
}

export default EditableCardEntryFile;
